import { gql } from "@apollo/client";

export const MY_ORGANIZATION_QUERY = gql`
  query MyOrganization($portalUserId: Int!) {
    myOrganization(portalUserId: $portalUserId) {
      id
      name
      customer_id
    }
  }
`;

export const ORGANIZATION_MEMBERS_QUERY = gql`
  query OrganizationMembers($portalUserId: Int!) {
    organizationMembers(portalUserId: $portalUserId) {
      id
      organization_id
      portal_user_id
      role
      status
      user {
        id
        name
        email
        login
      }
    }
  }
`;

export const INVITE_ORGANIZATION_USER = gql`
  mutation InviteOrganizationUser(
    $portalUserId: Int!
    $email: String!
    $role: PortalMemberRole!
  ) {
    inviteOrganizationUser(
      portalUserId: $portalUserId
      email: $email
      role: $role
    ) {
      id
      organization_id
      email
      role
      expires_at
      accepted_at
    }
  }
`;

export const ORGANIZATION_INVITATIONS_QUERY = gql`
  query OrganizationInvitations($portalUserId: Int!) {
    organizationInvitations(portalUserId: $portalUserId) {
      id
      organization_id
      email
      role
      expires_at
      accepted_at
      created_at
    }
  }
    `;

export const CANCEL_ORGANIZATION_INVITATION = gql`
  mutation CancelOrganizationInvitation(
    $portalUserId: Int!
    $invitationId: Int!
  ) {
    cancelOrganizationInvitation(
      portalUserId: $portalUserId
      invitationId: $invitationId
    )
  }
`;

export const RESEND_ORGANIZATION_INVITATION = gql`
  mutation ResendOrganizationInvitation(
    $portalUserId: Int!
    $invitationId: Int!
  ) {
    resendOrganizationInvitation(
      portalUserId: $portalUserId
      invitationId: $invitationId
    ) {
      id
      email
      role
      expires_at
      accepted_at
    }
  }
`;

export const DISABLE_ORGANIZATION_USER = gql`
  mutation DisableOrganizationUser(
    $portalUserId: Int!
    $membershipId: Int!
  ) {
    disableOrganizationUser(
      portalUserId: $portalUserId
      membershipId: $membershipId
    ) {
      id
      role
      status
    }
  }
`;

export const ENABLE_ORGANIZATION_USER = gql`
  mutation EnableOrganizationUser(
    $portalUserId: Int!
    $membershipId: Int!
  ) {
    enableOrganizationUser(
      portalUserId: $portalUserId
      membershipId: $membershipId
    ) {
      id
      role
      status
    }
  }
`;

export const CHANGE_ORGANIZATION_USER_ROLE = gql`
  mutation ChangeOrganizationUserRole(
    $portalUserId: Int!
    $membershipId: Int!
    $role: PortalMemberRole!
  ) {
    changeOrganizationUserRole(
      portalUserId: $portalUserId
      membershipId: $membershipId
      role: $role
    ) {
      id
      role
      status
    }
  }
`;